@let utilizationsKpisFeatureFlagEnabled =
  !!('portal-shift-timeline-utilization-kpis' | featureFlagPure | async);
@let isLoadingUsersProductivity = isLoadingUsersProductivity$ | async;
@let loadingProductivityUserIds = loadingProductivityUserIds$ | async;
@let fetchingWeeklyKpiForUserIds = fetchingWeeklyKpiForUserIds$ | async;
@let fetchingMonthlyKpiForUserIds = fetchingMonthlyKpiForUserIds$ | async;
@let userKpisWeek = userKpisWeek$ | async;
@let userKpisMonth = userKpisMonth$ | async;
@let updatingKpiUserIds = updatingKpiUserIds$ | async;
@let currentDate = currentDate$ | async;

<div class="kpi-parent">
  @if (
    renderOvertimeAccountKpi &&
    ('portal-shift-timeline-overtime' | featureFlagPure | async) &&
    (FeatureName.Payroll | featurePure | async)
  ) {
    <wilson-overtime-value
      [overtimeInMinutes]="userOvertime$ | async"
      [isLoadingUsersOvertimes]="!!(isLoadingUsersOvertimes$ | async)"
    >
    </wilson-overtime-value>
  }
  @if (renderProductivityKpi) {
    @if (renderOvertimeAccountKpi) {
      <nz-divider nzType="vertical" class="h-100 m-0"></nz-divider>
    }
    <wilson-productivity-kpi
      [dateRange]="visibleDateRange$ | async"
      [productivity]="userProductivity$ | async"
      [isLoadingProductivity]="
        !!(
          isLoadingUsersProductivity ||
          loadingProductivityUserIds?.includes(user.id!)
        )
      "
    ></wilson-productivity-kpi>
  }
  @if (utilizationsKpisFeatureFlagEnabled) {
    @let isLoadingWeekKpi =
      !!(
        fetchingWeeklyKpiForUserIds?.includes(user.id!) ||
        updatingKpiUserIds?.includes(user.id!)
      );
    @let isLoadingMonthKpi =
      !!(
        fetchingMonthlyKpiForUserIds?.includes(user.id!) ||
        updatingKpiUserIds?.includes(user.id!)
      );
    @if (renderWorkTimeWeekKpi) {
      @if (renderOvertimeAccountKpi || renderProductivityKpi) {
        <nz-divider nzType="vertical" class="h-100 m-0"></nz-divider>
      }
      <wilson-kpi-value
        [kpiName]="'shift_timeline.kpi_setting.work_time' | translate"
        [kpiValueInMinutes]="userKpisWeek?.isWorkTimeSumInMinutes"
        [isLoadingKpiValue]="isLoadingWeekKpi"
        [kpiMode]="KpiMode.Week"
        [currentTimelineStartDate]="currentDate"
      ></wilson-kpi-value>
    }
    @if (renderPlannedTimeWeekKpi) {
      @if (
        renderOvertimeAccountKpi ||
        renderProductivityKpi ||
        renderWorkTimeWeekKpi
      ) {
        <nz-divider nzType="vertical" class="h-100 m-0"></nz-divider>
      }
      <wilson-kpi-value
        [kpiName]="'shift_timeline.kpi_setting.planned_time' | translate"
        [kpiValueInMinutes]="userKpisWeek?.plannedWorkTimeSumInMinutes"
        [isLoadingKpiValue]="isLoadingWeekKpi"
        [kpiMode]="KpiMode.Week"
        [currentTimelineStartDate]="currentDate"
      ></wilson-kpi-value>
    }
    @if (renderOvertimeWeekKpi) {
      @if (
        renderOvertimeAccountKpi ||
        renderProductivityKpi ||
        renderWorkTimeWeekKpi ||
        renderPlannedTimeWeekKpi
      ) {
        <nz-divider nzType="vertical" class="h-100 m-0"></nz-divider>
      }
      <wilson-kpi-value
        [kpiName]="'shift_timeline.kpi_setting.overtimes' | translate"
        [kpiValueInMinutes]="userKpisWeek?.overtimeInMinutes"
        [isLoadingKpiValue]="isLoadingWeekKpi"
        [kpiMode]="KpiMode.Week"
        [currentTimelineStartDate]="currentDate"
      ></wilson-kpi-value>
    }
    @if (renderWorkTimeMonthKpi) {
      @if (
        renderOvertimeAccountKpi ||
        renderProductivityKpi ||
        renderWorkTimeWeekKpi ||
        renderPlannedTimeWeekKpi ||
        renderOvertimeWeekKpi
      ) {
        <nz-divider nzType="vertical" class="h-100 m-0"></nz-divider>
      }
      <wilson-kpi-value
        [kpiName]="'shift_timeline.kpi_setting.work_time' | translate"
        [kpiValueInMinutes]="userKpisMonth?.isWorkTimeSumInMinutes"
        [isLoadingKpiValue]="isLoadingMonthKpi"
        [kpiMode]="KpiMode.Month"
        [currentTimelineStartDate]="currentDate"
      ></wilson-kpi-value>
    }
    @if (renderPlannedTimeMonthKpi) {
      @if (
        renderOvertimeAccountKpi ||
        renderProductivityKpi ||
        renderWorkTimeWeekKpi ||
        renderPlannedTimeWeekKpi ||
        renderOvertimeWeekKpi ||
        renderWorkTimeMonthKpi
      ) {
        <nz-divider nzType="vertical" class="h-100 m-0"></nz-divider>
      }
      <wilson-kpi-value
        [kpiName]="'shift_timeline.kpi_setting.planned_time' | translate"
        [kpiValueInMinutes]="userKpisMonth?.plannedWorkTimeSumInMinutes"
        [isLoadingKpiValue]="isLoadingMonthKpi"
        [kpiMode]="KpiMode.Month"
        [currentTimelineStartDate]="currentDate"
      ></wilson-kpi-value>
    }
    @if (renderOvertimeMonthKpi) {
      @if (
        renderOvertimeAccountKpi ||
        renderProductivityKpi ||
        renderWorkTimeWeekKpi ||
        renderPlannedTimeWeekKpi ||
        renderOvertimeWeekKpi ||
        renderWorkTimeMonthKpi ||
        renderPlannedTimeMonthKpi
      ) {
        <nz-divider nzType="vertical" class="h-100 m-0"></nz-divider>
      }
      <wilson-kpi-value
        [kpiName]="'shift_timeline.kpi_setting.overtimes' | translate"
        [kpiValueInMinutes]="userKpisMonth?.overtimeInMinutes"
        [isLoadingKpiValue]="isLoadingMonthKpi"
        [kpiMode]="KpiMode.Month"
        [currentTimelineStartDate]="currentDate"
      ></wilson-kpi-value>
    }
  }
  @if (renderHomeLocation) {
    @if (
      (renderOvertimeAccountKpi ||
        renderProductivityKpi ||
        renderWorkTimeWeekKpi ||
        renderPlannedTimeWeekKpi ||
        renderOvertimeWeekKpi ||
        renderWorkTimeMonthKpi ||
        renderPlannedTimeMonthKpi ||
        renderOvertimeMonthKpi) &&
      utilizationsKpisFeatureFlagEnabled
    ) {
      <nz-divider nzType="vertical" class="h-100 m-0"></nz-divider>
    }
    <wilson-home-location-value [user]="user"></wilson-home-location-value>
  }
</div>
